export const getHeaders = new Headers({
  'Content-Type': 'application/x-www-form-urlencoded',
});

export const postHeaders = new Headers({
  'Content-Type': 'application/json',
});
